import { getUserProfile } from "./getUserProfile"
import { updateUserProfile } from "./updateUserProfile"

export const updateUserRank = async(
    userId: string, 
    rankIncrease: number, 
    streakCount?: number,
    crowdBeats?: number
  ): Promise<{
    success: boolean
    newRank: number
    score?: number
    total?: number
  }> => {
    try {
      const currentProfile = await getUserProfile(userId)
      
      if (!currentProfile) {
        console.error('User profile not found for rank update')
        return { success: false, newRank: 0 }
      }

      const newRank = (currentProfile?.rank || 0) + rankIncrease
      const newStreak = streakCount !== undefined ? streakCount : currentProfile.streak
      const newCrowdBeats = crowdBeats !== undefined ? 
        currentProfile.crowd_beats + crowdBeats : currentProfile.crowd_beats

      const updatedProfile = await updateUserProfile(userId, {
        rank: newRank,
        streak: newStreak,
        crowd_beats: newCrowdBeats
      })

      if (!updatedProfile ) {
        return { success: false, newRank: (currentProfile.rank || 0) }
      }

      return {
        success: true,
        newRank
      }

    } catch (error) {
      console.error('Error updating user rank:', error)
      return { success: false, newRank: 0 }
    }
  }